/* eslint-disable react-hooks/exhaustive-deps */
import {
  Checkbox,
  Flex,
  Icon,
  Link,
  Text,
  Space,
  useColorMode,
  useColorStyle,
} from '@tonic-one/react';
import { SuccessIcon, WarningCircleIcon } from '@tonic-one/react-icons';
import { FormInput, FormLabel } from '@Components/Common/FormComponent';
import { Trans, useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';
import { useToggle } from '@tonic-one/react-hooks';
import { AdministrationApi, ProvisionApi } from '@Apis';
import { AuthenticationInfoRes, EnabledPolicyTypeEnum } from '@Types/provision';
import { deleteCookie, getProvisionCookie } from '../../../utils/common';
import { reportPendo } from '../../../utils/setupPendo';
import CSpinner from '../../../components/CSpinner';
import ErrorAlert from '../../../components/Common/ErrorAlert';
import Note from '@Components/Common/Note';
import { ApiTokenRes, ApiData, AppTokenType } from './types';
import { App } from '@Types/app';
const InputFrom = (props: {
  onChange: (apiTokenRes: ApiTokenRes) => void;
  isSaveDisable: (isSaveDisable: boolean) => void;
  orgId: string;
  category?: number;
  editTokenData?: ApiData | null;
}) => {
  const { t } = useTranslation('administration');
  const { onChange, isSaveDisable, orgId, category, editTokenData } = props;
  const [params, setState] = useState<ApiTokenRes>({
    category: 0,
    description: '',
    name: '',
    scope: {
      sweepingMails: false,
      mitigationMails: false,
      mitigationAccounts: false,
      siemSecurityEvents: false,
      remediationMails: false,
      intelligent: false,
    },
  });
  const [authenticationInfoMitigation, setAuthenticationInfoMitigation] =
    useState<null | AuthenticationInfoRes>(null);
  const [authenticationInfoSoc, setAuthenticationInfoSoc] =
    useState<null | AuthenticationInfoRes>(null);
  const [authenticationInfoSocManagement, setAuthenticationInfoSocManagement] =
    useState<null | AuthenticationInfoRes>(null);
  const [appTokenStatus, setAppTokenStatus] = useState<any>({});
  const { Mitigation, Soc, SocManagement } = App;
  const { MitigationGraphApi, SocGraphApi, SocManagementApi } = AppTokenType;
  useEffect(() => {
    if (editTokenData) {
      const selectedEditTokenData = {
        category: editTokenData.category,
        description: editTokenData.description || '',
        name: editTokenData.name,
        scope: editTokenData.scope,
      };
      setState(selectedEditTokenData);
    }
    if (category) {
      params.category = category;
    }
    isSaveDisable(true);
  }, [props.editTokenData, category]);
  const [errorMsg, setErrorMsg] = useState<string | undefined>(undefined);

  const [loading, toggleLoading] = useToggle(false);
  const cookieName = {
    [App.Mitigation]: 'provision_status_mitigation_api',
  }[Mitigation];

  const timeRef = useRef<any>(null);
  const onClick = async () => {
    const authUrl = authenticationInfoMitigation?.[0]?.authenticationUrl;
    if (!authUrl) {
      return;
    }
    reportPendo('Provision.GrantPermission.Click', {
      orgId,
      Mitigation,
    });
    setErrorMsg(undefined);
    toggleLoading(true);
    window.open(authUrl, '_blank');
    if (timeRef.current) {
      clearInterval(timeRef.current);
    }
    timeRef.current = setInterval(async () => {
      const provisionInfo = getProvisionCookie(cookieName);
      if (provisionInfo) {
        clearInterval(timeRef.current);
        deleteCookie('provision_status_');
        const { error, code } = JSON.parse(provisionInfo);
        if (error === undefined || error.length === 0) {
          try {
            const res = await ProvisionApi.apiSaveProvisionInfo(
              Mitigation,
              code,
              EnabledPolicyTypeEnum.None,
              orgId
            );
            if (res.data?.status === 'failure') {
              setErrorMsg(
                t([
                  `provision:provision.service.${Mitigation}.error.saveInfo.${res.data?.reason}`,
                  'common.apiException.internalError',
                ])
              );
            } else {
              // setCommonStatus(CommonStatus.Provisioning);
            }
          } catch {
            setErrorMsg(t('common.apiException.internalError'));
          }
        } else {
          setErrorMsg(
            t(`provision:provision.service.${Mitigation}.error.deniedGrant`)
          );
        }
        toggleLoading(false);
      }
    }, 1000);
  };

  useEffect(() => {
    if (timeRef.current) {
      clearInterval(timeRef.current);
    }
    return () => {
      if (timeRef.current) {
        clearInterval(timeRef.current);
      }
    };
  }, []);

  useEffect(() => {
    AdministrationApi.apiTokensO365TokenExistence().then((res) => {
      setAppTokenStatus(res.data);
      if (res.data[MitigationGraphApi] === false) {
        ProvisionApi.apiGetAuthenticationInfo(Mitigation, orgId).then((res) => {
          setAuthenticationInfoMitigation(res.data);
        });
      }
      if (res.data[SocGraphApi] === false && params.scope.intelligent) {
        ProvisionApi.apiGetAuthenticationInfo(Soc, orgId).then((res) => {
          setAuthenticationInfoSoc(res.data);
        });
      }
      if (res.data[SocManagementApi] === false && params.scope.intelligent) {
        ProvisionApi.apiGetAuthenticationInfo(SocManagement, orgId).then(
          (res) => {
            setAuthenticationInfoSocManagement(res.data);
          }
        );
      }
    });
  }, []);
  const handleChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    const _params = JSON.parse(JSON.stringify(params));
    if (e.target.name.indexOf('scope') !== -1) {
      const name = e.target.name.split('scope.').join('');
      _params['scope'][name] = e.target.checked;
    } else {
      _params[e.target.name] = e.target.value;
    }
    _params.status = appTokenStatus[MitigationGraphApi];
    setState(_params);
    onChange(_params);
    let index = 0;
    for (const item in _params.scope) {
      if (_params.scope[item]) index++;
    }
    isSaveDisable(!(_params.name !== '' && index !== 0));
  };
  const ValidIcon = () => {
    const [colorMode] = useColorMode();
    const [colorStyle] = useColorStyle({ colorMode });
    return <Icon as={SuccessIcon} color={colorStyle.color.success} />;
  };

  const InvalidIcon = () => {
    const [colorMode] = useColorMode();
    const [colorStyle] = useColorStyle({ colorMode });
    return <Icon as={WarningCircleIcon} color={colorStyle.color.error} />;
  };
  return (
    <>
      {loading && <CSpinner />}
      {errorMsg && (
        <ErrorAlert
          errorMsg={errorMsg}
          onClose={() => setErrorMsg(undefined)}
        />
      )}
      <Flex direction="column">
        <Flex mt="22px" alignItems="flex-start">
          <FormLabel
            label={t('administration.apiToken.table.label.name')}
            required
          />
          <FormInput
            required
            value={params.name}
            name="name"
            onChange={handleChangeValue}
            maxLength={128}
          />
        </Flex>
        <Flex mt="23px" alignItems="flex-start">
          <FormLabel
            label={t('administration.apiToken.table.label.description')}
          />
          <FormInput
            value={params.description}
            name="description"
            onChange={handleChangeValue}
            maxLength={1024}
          />
        </Flex>
        <Flex mt="23px" alignItems="flex-start">
          <Text>{t('administration.apiToken.table.label.content')}</Text>
        </Flex>
      </Flex>
      <Flex m="16px 0px" flexDirection="row">
        <Text fontSize="md" lineHeight="md" minWidth={180} maxWidth={200}>
          {t('administration.apiToken.table.scopeName.sweepingMails')}
        </Text>
        <Space width="2x" />
        <Text pl="20px">
          <Space minWidth={260} maxWidth={260}>
            <Checkbox
              checked={params.scope.sweepingMails}
              onChange={handleChangeValue}
              name="scope.sweepingMails"
            >
              {t('administration.apiToken.table.apiType.emails')}
            </Checkbox>
          </Space>
          <Space
            width="60%"
            dangerouslySetInnerHTML={{
              __html: `${t(
                'administration.apiToken.table.sweepingMails.content'
              )}`,
            }}
          ></Space>
        </Text>
      </Flex>

      <Flex m="16px 0px" flexDirection="row">
        <Text fontSize="md" lineHeight="md" minWidth={180} maxWidth={200}>
          {t('administration.apiToken.table.scopeName.mitigation')}
        </Text>
        <Space width="2x" />
        <Text pl="20px">
          <Text>
            <Space minWidth={260} maxWidth={260}>
              <Checkbox
                checked={params.scope.mitigationMails}
                onChange={handleChangeValue}
                name="scope.mitigationMails"
              >
                {t('administration.apiToken.table.apiType.emails')}
              </Checkbox>
            </Space>
            <Space
              width="60%"
              dangerouslySetInnerHTML={{
                __html: `${t(
                  'administration.apiToken.table.mitigationMails.content'
                )}`,
              }}
            ></Space>
          </Text>
          <br />
          <Text>
            <Space minWidth={260} maxWidth={260}>
              <Checkbox
                checked={params.scope.mitigationAccounts}
                onChange={handleChangeValue}
                name="scope.mitigationAccounts"
              >
                {t('administration.apiToken.table.apiType.account')}
              </Checkbox>
            </Space>
            <Space
              width="60%"
              dangerouslySetInnerHTML={{
                __html: `${t(
                  'administration.apiToken.table.mitigationAccounts.content'
                )}`,
              }}
            ></Space>
            {params.scope.mitigationAccounts && (
              <>
                <Text width="60%" ml={260} mt="10px" position="relative">
                  {appTokenStatus[MitigationGraphApi] && (
                    <Space position="absolute" left="-30px">
                      <ValidIcon />
                    </Space>
                  )}
                  <Trans
                    i18nKey={`administration.apiToken.table.mitigationAccounts.clickHere`}
                  >
                    placeholder
                    <Link
                      m="0 5px"
                      disabled={appTokenStatus[MitigationGraphApi]}
                      onClick={() => {
                        onClick();
                      }}
                    >
                      Click here
                    </Link>
                    placeholder
                  </Trans>
                </Text>
              </>
            )}
          </Text>
        </Text>
      </Flex>

      <Flex m="16px 0px" flexDirection="row">
        <Text fontSize="md" lineHeight="md" minWidth={180} maxWidth={200}>
          {t('administration.apiToken.table.scopeName.siemSecurityEvents')}
        </Text>
        <Space width="2x" />
        <Text pl="20px">
          <Space minWidth={260} maxWidth={260}>
            <Checkbox
              checked={params.scope.siemSecurityEvents}
              onChange={handleChangeValue}
              name="scope.siemSecurityEvents"
            >
              {t('administration.apiToken.table.apiType.security')}
            </Checkbox>
          </Space>
          <Space width="60%">
            {t('administration.apiToken.table.siemSecurityEvents.content')}
          </Space>
        </Text>
      </Flex>
      {params.scope.intelligent && (
        <Flex m="16px 0px" flexDirection="row">
          <Text fontSize="md" lineHeight="md" minWidth={180} maxWidth={200}>
            {t('administration.apiToken.table.scopeName.intelligent')}
          </Text>
          <Space width="2x" />
          <Text pl="20px">
            <Space minWidth={260} maxWidth={260}>
              <Checkbox
                checked={params.scope.intelligent}
                onChange={handleChangeValue}
                name="scope.intelligent"
              >
                {t('administration.apiToken.table.apiType.intelligent')}
              </Checkbox>
            </Space>
            <Space
              width="60%"
              dangerouslySetInnerHTML={{
                __html: `${t(
                  'administration.apiToken.table.intelligent.content'
                )}`,
              }}
            ></Space>
            {params.scope.intelligent && (
              <>
                <Text width="60%" ml={260} mt="10px" position="relative">
                  {appTokenStatus[SocGraphApi] && (
                    <Space position="absolute" left="-30px">
                      <ValidIcon />
                    </Space>
                  )}
                  <Trans
                    i18nKey={`administration.apiToken.table.intelligent.step1`}
                  >
                    placeholder
                    <Link
                      m="0 5px"
                      disabled={appTokenStatus[SocGraphApi]}
                      onClick={() => {
                        window.open(
                          authenticationInfoSoc?.[0]?.authenticationUrl || '',
                          '_blank'
                        );
                      }}
                    >
                      Click here
                    </Link>
                    placeholder
                  </Trans>
                </Text>
                <Text width="60%" ml={260} mt="10px" position="relative">
                  {appTokenStatus[SocManagementApi] && (
                    <Space position="absolute" left="-30px">
                      <InvalidIcon />
                    </Space>
                  )}
                  <Trans
                    i18nKey={`administration.apiToken.table.intelligent.step2`}
                  >
                    placeholder
                    <Link
                      m="0 5px"
                      disabled={appTokenStatus[SocManagementApi]}
                      onClick={() => {
                        window.open(
                          authenticationInfoSocManagement?.[0]
                            ?.authenticationUrl || '',
                          '_blank'
                        );
                      }}
                    >
                      Click here
                    </Link>
                    placeholder
                  </Trans>
                </Text>
                <Text width="60%" ml={260} mt="10px" position="relative">
                  <Trans
                    i18nKey={`administration.apiToken.table.intelligent.step3`}
                  >
                    placeholder
                    <Link
                      m="0 5px"
                      onClick={() => {
                        window.open(
                          authenticationInfoSocManagement?.[0]
                            ?.authenticationUrl || '',
                          '_blank'
                        );
                      }}
                    >
                      Click here
                    </Link>
                    placeholder
                  </Trans>
                </Text>
              </>
            )}
          </Text>
        </Flex>
      )}
      <Flex m="16px 0px" flexDirection="row">
        <Text fontSize="md" lineHeight="md" minWidth={180} maxWidth={200}>
          {t('administration.apiToken.table.scopeName.remediationMails')}
        </Text>
        <Space width="2x" />
        <Text pl="20px">
          <Space minWidth={260} maxWidth={260}>
            <Checkbox
              checked={params.scope.remediationMails}
              onChange={handleChangeValue}
              name="scope.remediationMails"
            >
              {t('administration.apiToken.table.apiType.emails')}
            </Checkbox>
          </Space>
          <Space
            width="60%"
            dangerouslySetInnerHTML={{
              __html: `${t(
                'administration.apiToken.table.remediationMails.content'
              )}`,
            }}
          ></Space>
        </Text>
      </Flex>
      <Note content={t('administration.apiToken.note')} />
    </>
  );
};

export default InputFrom;
